import React from "react";
import MaterialList from "components/cards/MaterialList.js";

export default ({ headingText = "Bible Basics Material" }) => {
	return <MaterialList table="bb_material" headingText={headingText} />;
};
